// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"b497df64","453":"93de74a4"}[chunkId] + ".chunk.js";
};